<template>
  <v-card flat style="max-width: 100%;">
    <v-card-title class="pb-2 pt-2 px-0">
      <v-subheader>Timeline</v-subheader>
      <v-tooltip right>
        <v-icon small color="#ccc" slot="activator">help</v-icon>
        <span
          >Quick visualization of how expeditions are spreaded through
          time</span
        >
      </v-tooltip>
    </v-card-title>

    <v-card-text class="py-0">
      <v-layout row wrap align-center v-if="!loading">
        <v-flex xs12>
          <apexchart
            type="rangeBar"
            width="100%"
            :height="Math.min(120 + 22 * expeditions.length, 420)"
            :options="options"
            :series="series"
          />
        </v-flex>
      </v-layout>

      <!-- <v-layout row justify-center align-center v-if="!loading && !series.length" class="pa-4">
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No expenses found
        </span>
      </v-layout>-->

      <div class="pa-4 text-xs-center" v-if="loading">
        <looping-rhombuses-spinner
          style="margin: auto;"
          class="text-xs-center"
          :animation-duration="1000"
          :size="74"
          color="#1976d2"
        />
        <h3 class="title font-weight-light my-2">Loading Chart...</h3>
        <span class="caption grey--text">Please wait</span>
      </div>
    </v-card-text>
    <!-- <json-viewer :value="series"></json-viewer> -->
    <!-- <json-viewer :value="expeditionsIds"></json-viewer> -->
  </v-card>
</template>

<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import date from "../../mixins/date";

import JsonViewer from "vue-json-viewer";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  name: "expeditionTimelineGraph",

  components: { apexchart, JsonViewer, LoopingRhombusesSpinner },
  mixins: [date],
  props: {
    expeditions: {
      type: Array,
      required: true,
    },
    contract_name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      expeditionsIds: {
        onProgress: [],
        completed: [],
      },
      options: {
        colors: ["#ffb300", "#4caf50"],

        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            dataLabels: {
              hideOverflowingLabels: false,
            },
          },
        },
        chart: {
          height: 350,
          type: "rangeBar",
          events: {
            click: this.clickOn,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          type: "datetime",
          // zoom: {
          //   autoScaleXaxis: true
          // }
        },
      },
    };
  },
  computed: {
    // ...mapGetters("commonStore", ["accountTypes"]),

    series() {
      //retrieve all categories
      var completedArr = [];
      var onProgressArr = [];

      this.expeditions.forEach((exp) => {
        if (exp.eta && exp.etd) {
          if (this.stepsCompleted(exp) == exp.steps.length) {
            completedArr.push({
              x: this.contract_name + "." + exp.number,
              y: [new Date(exp.etd).getTime(), new Date(exp.eta).getTime()],
            });

            this.expeditionsIds.completed.push(exp.id);
          } else {
            onProgressArr.push({
              x: this.contract_name + "." + exp.number,
              y: [new Date(exp.etd).getTime(), new Date(exp.eta).getTime()],
            });
            this.expeditionsIds.onProgress.push(exp.id);
          }
        }
      });

      var retArr = [
        {
          name: "On-Progress",
          data: onProgressArr,
        },
        {
          name: "Completed",
          data: completedArr,
        },
      ];
      return retArr;
    },
  },
  methods: {
    clickOn(event, chartContext, config) {
      this.goToExpedition(
        this.expeditionsIds[config.seriesIndex ? "completed" : "onProgress"][
          config.dataPointIndex
        ]
      );
      // console.log(config.seriesIndex);
      // console.log(config.dataPointIndex);
      // console.log(config);
    },
    stepsCompleted(expedition) {
      let completed_steps = 0;

      expedition.steps.forEach((s) => {
        completed_steps += s.validated;
      });
      return completed_steps;
    },
    goToExpedition(expeditionID) {
      let query = { id: expeditionID };

      this.$router.push({
        name: "expeditions",
        query: query,
      });
    },
  },
};
</script>
